import React, { ReactElement, ReactNode } from 'react'

import { Tooltip as LemonadeTooltip, TooltipOptions } from '@percent/lemonade'

type TooltipProps = {
  title: ReactNode
  placement?: TooltipOptions['placement']
  children: ReactElement
}

export function Tooltip({ title, placement, children }: TooltipProps) {
  return (
    <LemonadeTooltip content={title} placement={placement}>
      {children}
    </LemonadeTooltip>
  )
}

export function EmailTooltip(props: TooltipProps) {
  return <Tooltip placement="top-start" {...props} />
}
